import React, { useId } from 'react';

export interface DatacircleLogoMarkProps {
  className?: string;
  /** Сторона квадрата в px (viewBox квадратный 256×256) */
  size?: number;
}

/** Логотип-знак datacircle (градиент + три столбика), тот же мотив, что в XLSX-экспорте */
export const DatacircleLogoMark: React.FC<DatacircleLogoMarkProps> = ({ className, size = 32 }) => {
  const uid = useId().replace(/:/g, '');
  const gradId = `dc-logo-bg-${uid}`;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      width={size}
      height={size}
      role="img"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#1a237e" />
          <stop offset="1" stopColor="#283593" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="256" height="256" rx="36" fill={`url(#${gradId})`} />
      <g transform="translate(70 62)" fill="#ffffff">
        <rect x="0" y="72" width="28" height="64" rx="8" />
        <rect x="42" y="32" width="28" height="104" rx="8" />
        <rect x="84" y="0" width="28" height="136" rx="8" />
      </g>
    </svg>
  );
};
